import styled from 'styled-components';

export const ActiveOverlayWrapper = styled.div`
    background: ${({ theme }) => theme.colors.white};
    width: 268px;
    border: 1px solid ${({ theme }) => theme.colors.charcoal20};
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    margin-top: 10px;
`;

export const ActiveOverlayPointerWrapper = styled(ActiveOverlayWrapper)`
    :before {
        content: '';
        background: ${({ theme }) => theme.colors.white};
        border-top: 1px solid ${({ theme }) => theme.colors.charcoal20};
        border-left: 1px solid ${({ theme }) => theme.colors.charcoal20};
        width: 10px;
        height: 10px;
        position: absolute;
        top: 5px;
        right: 21px;
        transform: rotate(45deg);
    }
`;

export default ActiveOverlayPointerWrapper;
